import { render } from "./AppGalery.vue?vue&type=template&id=134ee81a&scoped=true"
import script from "./AppGalery.vue?vue&type=script&lang=js"
export * from "./AppGalery.vue?vue&type=script&lang=js"

import "./AppGalery.vue?vue&type=style&index=0&id=134ee81a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\petr.hric\\Desktop\\MyDrive\\web\\mkosmeo\\mkosmeo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-134ee81a"]])

export default __exports__